var root = location.href;
var bool = root.includes("https://abr-net.com//");
if(bool){
    location.href = 'https://abr-net.com/wellnessSupportToolsSec/';
}


// WEBPACK FOOTER //
// src/assets/js/routing.js